import React, { Component } from "react";
import { Container, Row, Col } from "reactstrap";

import ImgA from "../../assets/images/ourvillage.jpg";
import WaitlistForm from "../../component/WaitlistForm";

class Section extends Component {
  constructor() {
    super();
    const experiments = [
      {
        waitlist_version: 1,
        waitlist_name: "ourvillage",
        header: "Need a break from your little ones? ",
        subheader:
          "Build friendships with moms near you and take turns babysitting to give each other a much needed break.",
        CTA: "Notify me when Our Village is available!",
        img: ImgA,
      },
    ];

    // Check if an experiment is already stored in localStorage
    // const persistedExperiment = localStorage.getItem("selectedExperiment");
    const selectedExperiment = experiments[0];

    // // Save the selected experiment to localStorage if it wasn't already saved
    // if (!persistedExperiment) {
    //   localStorage.setItem(
    //     "selectedExperiment",
    //     JSON.stringify(selectedExperiment)
    //   );
    // }
    this.state = {
      isOpen: false,
      selectedExperiment,
    };

    this.openModal = this.openModal.bind(this);
  }

  openModal() {
    this.setState({ isOpen: true });
  }

  render() {
    const { header, subheader, img } = this.state.selectedExperiment;

    return (
      <React.Fragment>
        <section className="bg-home bg-light" id="home">
          <div className="home-center">
            <div className="home-desc-center">
              <Container>
                <Row className="align-items-center">
                  <Col lg={6}>
                    <div className="home-content">
                      <div className="home-img">
                        <div className="animation-4"></div>
                      </div>
                      <p className="biz-name mt-4 mb-0">OUR VILLAGE</p>
                      <h1 className="home-title mt-4">{header}</h1>
                      <p className="text-muted mt-4 f-20">{subheader}</p>
                      <WaitlistForm
                        selectedExperiment={this.state.selectedExperiment}
                      />
                      <p className="text-muted mt-4 f-10 text-center">
                        We'll never share your information with anyone.
                      </p>
                    </div>
                  </Col>
                  <Col lg={6}>
                    <div className="home-img">
                      <div className="animation-1"></div>
                      <div className="animation-2"></div>
                      <div className="animation-3"></div>
                      <div className="hero">
                        <img
                          src={img}
                          className="img-fluid hero-photo"
                          alt=""
                        />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default Section;
